module.exports = __webpack_public_path__ + "media/images/mobile/solutions/14-1ef0b771a1bc5b29f6b69ce6e8047522.png";